import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=a8cb361a"
import script from "./chapter.vue?vue&type=script&lang=js"
export * from "./chapter.vue?vue&type=script&lang=js"
import style0 from "./chapter.vue?vue&type=style&index=0&id=a8cb361a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports